import { render, staticRenderFns } from "./HeaderNavMenuSsronly.vue?vue&type=template&id=38c8d0a0&"
import script from "./HeaderNavMenuSsronly.vue?vue&type=script&lang=ts&"
export * from "./HeaderNavMenuSsronly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports